<template>
    <div>
        <DataTable :value="horseColors" lazy paginator dataKey="id"
                   v-model:rows="searchCriteria.page.limit" v-model:first="searchCriteria.page.offset" removableSort
                   :totalRecords="totalRecords" :loading="loading" @page="onPage"
                   @sort="onPage" :rowsPerPageOptions="[5,10,20,50]"
                   selection-mode="single" v-model:selection="selectedTableElement" @row-click="onRowSelect"
                   filterDisplay="row" v-model:filters="searchCriteria" @update:filters="search" scrollable
                   scrollHeight="calc(100vh - 300px)">
            <Column field="name" :header="$t('message.horseColor.name')" :sortable="true" filterField="name"
                :showFilterMenu="false" :showClearButton="false">
                <template #body="{ data }">
                    {{ data.name }}
                </template>
                <template #filter>
                    <CustomInputText name="name"
                        v-model="searchCriteria.name" @update:modelValue="search"/>
                </template>
            </Column>
            <Column field="abbreviation" :header="$t('message.horseColor.abbreviation')" filterField="abbreviation" :showFilterMenu="false" :showClearButton="false">
                <template #body="{ data }">
                    {{ data.shortName }}
                </template>
                <template #filter>
                    <CustomInputText name="abbreviation"
                                     v-model="searchCriteria.shortName" @update:modelValue="search"/>
                </template>
            </Column>
            <template #empty>
                {{ $t('message.other.emptyTable') }}
            </template>
        </DataTable>
    </div>
</template>

<script>
import Button from "primevue/button";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import { searchHorseColor, searchHorseColorCount } from "@/swagger/vue-api-client";
import CustomInputText from "@/components/form/CustomInputText.vue";
import { ScrollToUtils } from "@/utils/ScrollToUtils";

export default {
    name: "HorseColorTable",
    components: {
        CustomInputText,
        Button,
        Column,
        DataTable,
    },

    props: {
        modelValue: null,
    },

    emits: ["update:modelValue", "showForm"],

    data() {
        return {
            loading: false,
            totalRecords: 0,
            horseColors: [],
            searchCriteria: this.getClearSearchCriteria(),
            selectedTableElement: null,
        };
    },

    mounted() {
        this.updateTotalRecords();
        this.onPage(this.getFirstPage());
    },

    methods: {
        search() {
            this.onPage(this.getFirstPage());
            this.updateTotalRecords();
        },

        onPage(event) {
            this.loading = true;
            this.searchCriteria.page.offset = event.first;
            this.searchCriteria.page.limit = event.rows;
            this.searchCriteria.page.sortField = event.sortField;
            this.searchCriteria.page.sortOrder = event.sortOrder;

            searchHorseColor({ body: this.searchCriteria }).then((response) => {
                this.horseColors = response.data;
                this.loading = false;
            });
        },

        updateTotalRecords() {
            searchHorseColorCount({ body: this.searchCriteria }).then((response) => {
                this.totalRecords = response.data;
            });
        },

        getFirstPage() {
            return {
                first: this.searchCriteria.page.offset,
                rows: this.searchCriteria.page.limit,
            };
        },

        onRowSelect(event) {
            ScrollToUtils.scrollToElement();
            this.$emit("showForm");
            this.selectedColor = event.data;
        },

        getClearSearchCriteria() {
            return {
                code: "",
                name: "",
                abbreviation: "",
                page: {
                    limit: 10,
                    offset: 0,
                    sortField: null,
                    sortOrder: null,
                },
            };
        },

        addNewColor() {
            this.selectedTableElement = null;
        },

        reloadTable() {
            this.search();
        },
    },

    computed: {
        selectedColor: {
            get() { return this.modelValue; },
            set(value) { this.$emit("update:modelValue", value); },
        },
    },
};
</script>

<style lang="less" scoped>
</style>
